<template>
	<div class="three-meeting">
		<el-collapse v-model="activeNames">
			<el-collapse-item name="1" v-if="!showLastList">
        <template slot="title">
          Shakehand Meeting<span class="star" v-if="companyOrRepresentative === '1'">*</span>
        </template>
        <el-button v-has="{ class: 'majorFileOperation' }" type="primary" size="small" icon="el-icon-upload2" v-if="allData && allData.projectStatus !== 5" @click="openUpload(3)" style="margin-bottom: 10px">Upload</el-button>
        <el-table :data="disclosureMeetingData" border v-loading="disclosureLoading" style="width: 100%" tooltip-effect="dark" :header-cell-style="{background:'#F5F5F9'}">
          <el-table-column prop="id" label="id" v-if="false"></el-table-column>
          <el-table-column type="index" label="No." width="50" align="center"></el-table-column>
          <el-table-column prop="fileName" label="File Name" align="center" min-width="500">
            <template slot-scope="scope">
              <a style="color:blue;" @click="downloadFile(scope.row)">{{ scope.row.fileName }}</a>
            </template>
          </el-table-column>
          <el-table-column label="Operation" align="center" width="200">
            <template slot-scope="scope">
              <el-button v-has="{ class: 'majorFileOperation' }" size="small" type="danger" v-if="allData && allData.projectStatus !== 5" @click="handleDelete(scope.row, 3)">Delete</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-collapse-item>
      <el-collapse-item name="2" v-if="!showLastList">
        <template slot="title">
          Project Kick-off Meeting<span class="star" v-if="companyOrRepresentative === '1'">*</span>
        </template>
        <el-button v-has="{ class: 'majorFileOperation' }" type="primary" size="small" icon="el-icon-upload2" v-if="allData && allData.projectStatus !== 5" @click="openUpload(4)" style="margin-bottom: 10px">Upload</el-button>
        <el-table :data="kickOffMeetingData" border v-loading="kickOffLoading" style="width: 100%" tooltip-effect="dark" :header-cell-style="{background:'#F5F5F9'}">
          <el-table-column prop="id" label="id" v-if="false" ></el-table-column>
          <el-table-column type="index" label="No." width="50" align="center"></el-table-column>
          <el-table-column prop="fileName" label="File Name" align="center" min-width="500">
            <template slot-scope="scope">
              <a style="color:blue;" @click="downloadFile(scope.row)">{{ scope.row.fileName }}</a>
            </template>
          </el-table-column>
          <el-table-column label="Operation" align="center" width="200">
            <template slot-scope="scope">
              <el-button v-has="{ class: 'majorFileOperation' }" size="small" type="danger" v-if="allData && allData.projectStatus !== 5" @click="handleDelete(scope.row, 4)">Delete</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-collapse-item>
      <el-collapse-item name="3" v-if="showLastList">
        <template slot="title">
          Project Engineering Transfer Maintenance Meeting<span class="star">*</span>
        </template>
        <el-button v-has="{ class: 'majorFileOperation' }" type="primary" size="small" icon="el-icon-upload2" v-if="allData && allData.projectStatus !== 5" @click="openUpload(5)" style="margin-bottom: 10px">Upload</el-button>
        <el-table :data="handoverMeetingData" border v-loading="handoverLoading" style="width: 100%" tooltip-effect="dark" :header-cell-style="{background:'#F5F5F9'}">
          <el-table-column prop="id" label="id" v-if="false" ></el-table-column>
          <el-table-column type="index" label="No." width="50" align="center"></el-table-column>
          <el-table-column prop="fileName" label="File Name" align="center" min-width="500">
            <template slot-scope="scope">
              <a style="color:blue;" @click="downloadFile(scope.row)">{{ scope.row.fileName }}</a>
            </template>
          </el-table-column>
          <el-table-column label="Operation" align="center" width="200">
            <template slot-scope="scope">
              <el-button v-has="{ class: 'majorFileOperation' }" size="small" type="danger" v-if="allData && allData.projectStatus !== 5" @click="handleDelete(scope.row, 5)">Delete</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-collapse-item>
    </el-collapse>
		<el-dialog
			title="Upload"
			width="500px"
			:visible.sync="uploadVisible"
			:close-on-click-modal="false"
		>
			<el-form :model="uploadForm" ref="uploadForm" label-width="85px">
				<el-form-item label="File:" prop="file" :rules="[{ required: true, message: 'Please upload' }]">
					<el-upload
						class="upload-demo"
            action="#"
            :http-request="changeFile"
            :file-list="fileList"
            :show-file-list="false"
            :before-upload="beforeUpload"
            :limit="1"
            :on-exceed="handleExceed"
						v-model="uploadForm.file"
					>
						<el-button size="small" type="primary">Upload</el-button>
					</el-upload>
          <div class="el-upload-newlist">
            <div v-for="(item, index) in fileList" :key="index" class="el-upload-file-box">
              <a class="file-name"><i class="el-icon-document" />{{ item.name }}</a>
              <label>
                <span class="percentage" v-if="item.uploadPercentage > 0 && item.uploadPercentage < 100">{{ item.uploadPercentage }}%</span>
                <i class="el-icon-circle-check icon-check" style="color: #67c23a" v-if="item.id || item.uploadPercentage === 100"></i>
                <i class="el-icon-close icon-close" style="display: none" @click="handleRemove"></i>
              </label>
              <el-progress v-if="item.uploadPercentage > 0 && item.uploadPercentage < 100" :show-text="false" :stroke-width="2" :percentage="item.uploadPercentage"></el-progress>
            </div>
          </div>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button size="small" @click="closeUpload()">Cancel</el-button>
				<el-button type="primary" :loading="confirmLoading" size="small" @click="confirmFile()">Confirm</el-button>
			</span>
		</el-dialog>
	</div>
</template>
<script>
	import axios from 'axios'
  export default {
    name: 'threeMeeting',
		props: {
			id: {
        type: Number,
        default: null,
      },
			companyOrRepresentative: {
				type: String,
        default: '',
			},
      showLastList: {
				type: Boolean,
        default: false,
			},
			allData: {
				type: Object,
        default: {},
			},
		},
    mounted() {
      this.getList();
    },
    data () {
      return {
				activeNames: ['1', '2', '3'],
        disclosureMeetingData: [],
        kickOffMeetingData: [],
        handoverMeetingData: [],
        disclosureLoading: false,
        kickOffLoading: false,
        handoverLoading: false,
        uploadVisible: false,
        uploadForm: {},
        fileList: [],
        confirmLoading: false,
        cancelUpload: null,
      }
    },
    methods: {
      getList(type) {
        if((!type || type === 3) && !this.showLastList) {
          this.disclosureLoading = true
          let url =`${this.$store.state.islhurl}projectFile/getMeetingData?projectId=${this.id}&&islhToken=${sessionStorage.getItem('islhtoken')}&&fileType=${3}`;
          this._post(url).then(
            res => {
              this.disclosureLoading = false;
              if(res.code === 200) {
                this.disclosureMeetingData = res.data;
              } else {
                this.$message.error(res.message || 'Failed!' );
              }
            }
          )
        }
        if((!type || type === 4) && !this.showLastList) {
          this.kickOffLoading = true
          let url =`${this.$store.state.islhurl}projectFile/getMeetingData?projectId=${this.id}&&islhToken=${sessionStorage.getItem('islhtoken')}&&fileType=${4}`;
          this._post(url).then(
            res => {
              this.kickOffLoading = false;
              if(res.code === 200) {
                this.kickOffMeetingData = res.data;
              } else {
                this.$message.error(res.message || 'Failed!' );
              }
            }
          )
        }
        if((!type || type === 5) && this.showLastList) {
          this.handoverLoading = true
          let url =`${this.$store.state.islhurl}projectFile/getMeetingData?projectId=${this.id}&&islhToken=${sessionStorage.getItem('islhtoken')}&&fileType=${5}`;
          this._post(url).then(
            res => {
              this.handoverLoading = false;
              if(res.code === 200) {
                this.handoverMeetingData = res.data;
              } else {
                this.$message.error(res.message || 'Failed!' );
              }
            }
          )
        }
      },
      downloadFile(row) {
        if(row.fileAliasName && row.fileName) {
          window.open(`${this.$store.state.islhurl}s3/download?fileAliasName=${encodeURIComponent(row.fileAliasName)}&fileName=${encodeURIComponent(row.fileName)}`);
        }
      },
      openUpload(type) {
        this.uploadForm = {
          type
        };
        this.uploadVisible = true;
      },
      closeUpload() {
        this.uploadVisible = false;
        this.fileList = [];
        this.uploadForm = {};
      },
			beforeUpload(file) {
        const isLt2M = file.size / 1024 / 1024 < 200;
        if (!isLt2M) {
          this.$message.error('File cannot be larger than 200MB!');
          return false;
        }
      },
			changeFile(row) {
				const file = row.file;
				let fd = new FormData();
				fd.append('file', file);
				let params = {
					islhToken: sessionStorage.getItem("islhtoken"),
				}
				fd.append('fileParam', new Blob([JSON.stringify(params)], {type: 'application/json'}));
				let url = `${this.$store.state.islhurl}s3/upload`
				// 创建 CancelToken
				const CancelToken = axios.CancelToken;
				const source = CancelToken.source();
				this.cancelUpload = source.cancel; // 存储取消函数
				this._post(url, fd, {
					cancelToken: source.token, // 绑定 CancelToken
					onUploadProgress: (percent) => {
						this.fileList = [{
							name: file.name,
							uid: file.uid,
							uploadPercentage: percent === 100 ? 99 : percent,
						}];
						// 通知Upload组件内部进度更新
					},
					noProgress: true // 禁用全局NProgress
				}).then(res => {
					if(res.code == 200) {
            this.fileList = [{
              ...file,
              name: file.name,
              uid: file.uid,
              id: res.data.id,
              fileId: res.data.id,
							uploadPercentage: 100,
            }];
            this.uploadForm = {
              ...this.uploadForm,
              file: file
            };
					} else {
						this.fileList = [];
						this.$message.error(res.message || 'Failed!' );
					}
				}).catch(error => {
					console.log(error)
					this.fileList = [];
				})
      },
			handleRemove(file) {
				if (typeof this.cancelUpload === 'function') {
					this.cancelUpload('User canceled upload');
					this.cancelUpload = null;
				}
        this.fileList = [];
				this.uploadForm = {
					...this.uploadForm,
					file: []
				};
			},
      handleExceed() {
        this.$message.warning('Only one file is allowed for upload.');
      },
      handleDelete(row, type) {
        this.$confirm("Are you sure to delete the file", "Warning", {
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          let url = `${this.$store.state.islhurl}projectFile/deleteFileById?idParam=${row.id}&&islhToken=${sessionStorage.getItem('islhtoken')}`
          this._post(url).then(
            res =>{
              if(res.code === 200) {
                this.getList(type);
                this.$Message.success('Delete Successful' )
              } else {
                this.$message({
                  type:'error',
                  message: res
                });
              }
            }
          )
        }).catch(() => {
        });
      },
      confirmFile() {
        this.$refs.uploadForm.validate((valid) => {
					if (valid) {
            let fileParam = {
              projectId: this.id,
              fileType: this.uploadForm.type,
              islhToken: sessionStorage.getItem("islhtoken"),
            }
            if(this.fileList && this.fileList.length > 0) {
							fileParam.fileId = this.fileList[0].fileId;
						}
						let url =`${this.$store.state.islhurl}projectFile/save-file`;
						this.confirmLoading = true;
						this._post(url, fileParam).then(
							res => {
                this.confirmLoading = false;
								if(res.code === 200) {
									this.$Message.success('Upload successful!' );
                  this.getList(this.uploadForm.type)
									this.closeUpload()
								} else {
									this.$message.error(res.message || 'Failed!' );
								}
							}
						)
					}
				});
      },
		},
  }
</script>
<style lang="less" scoped>
  .star {
    color: #F56C6C;
    padding-left: 1px;
  }
  .el-upload-newlist {
    width: 300px;
    .el-upload-file-box {
      margin-top: 10px;
      border-radius: 4px;
      position: relative;
      line-height: 26px;
      .file-name {
        line-height: 26px;
        color: #606266;
        display: block;
        margin-right: 40px;
        overflow: hidden;
        padding-left: 4px;
        text-overflow: ellipsis;
        -webkit-transition: color .3s;
        transition: color .3s;
        white-space: nowrap;
        i {
          margin-right: 7px;
          color: #909399;
        }
      }
      .file-name:hover {
        color: #409eff;
      }
      label {
        position: absolute;
        right: 5px;
        top: 0;
        line-height: inherit;
        i {
          line-height: 26px;
        }
        .icon-close {
          cursor: pointer;
        }
        .percentage {
          color: #666;
          font-size: 12px;
        }
      }
    }
    .el-upload-file-box:hover {
      background-color: #f5f7fa;
      .icon-check, .percentage {
        display: none;
      }
      .icon-close {
        display: block !important;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/view/major/threeMeeting/index.vue